export const onContentLoaded = (handler) => {
    if (['complete', 'loaded', 'interactive'].includes(document.readyState)) {
        handler();
    }
    else {
        document.addEventListener('DOMContentLoaded', handler);
    }
};
export const parentQuerySelector = (element, selector) => {
    const collection = document.querySelectorAll(selector);
    for (const possibleParent of collection) {
        if (possibleParent.contains(element)) {
            return possibleParent;
        }
    }
};
